module.exports = __webpack_public_path__ + "img/1.56caa503.jpg";